<template>
    <layout>
        <!-- <div class="row mb-3 align-items-center">
            <div class="col">
                <PageHeader :title="title" />
            </div>
        </div> -->
        <div class="">
            <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-12 col-md-3" content-class="text-muted col-12 col-md-9">
                <b-tab title="General" active title-item-class="mb-2 customTabLink">
                    <b-card-text>
                        <div class="card">
                            <div class="card-body">
                                <div class="">
                                    <h2 class="titleCardStyle">Edit Profile </h2>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 col-lg-4 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">First Name</label>
                                            <input type="text" class="form-control" placeholder="First Name"
                                                v-model="client.firstName"
                                                :class="{ 'is-invalid': submitted && v$.client.firstName.$error, }">
                                            <div v-if="submitted && v$.client.firstName.$error"
                                                class="invalid-feedback">
                                                <span v-if="v$.client.firstName.required.$message">
                                                    {{ v$.client.firstName.required.$message }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Last Name</label>
                                            <input type="text" class="form-control" placeholder="Last Name"
                                                v-model="client.lastName"
                                                :class="{ 'is-invalid': submitted && v$.client.lastName.$error, }">
                                            <div v-if="submitted && v$.client.lastName.$error" class="invalid-feedback">
                                                <span v-if="v$.client.lastName.required.$message">
                                                    {{ v$.client.lastName.required.$message }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-3">
                                        <div class="">
                                            <label for="pen-name-input">Pen Name</label>
                                            <input id="pen-name-input" v-model="client.penName" type="text"
                                                class="form-control" placeholder="Pen Name" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Email</label>
                                            <input type="email" class="form-control" placeholder="Email"
                                                v-model="client.email"
                                                :class="{ 'is-invalid': submitted && v$.client.email.$error, }">
                                            <div v-for="(item, index) in v$.client.email.$errors" :key="index"
                                                class="invalid-feedback">
                                                <span v-if="item.$message">
                                                    {{ item.$message }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4 mb-3">
                                        <label for="street-address">Street Address *</label>
                                        <input id="street-address" type="text" class="form-control"
                                            placeholder="Street Address" v-model="client.street"
                                            :class="{ 'is-invalid': submitted && v$.client.street.$error, }">
                                        <div v-if="submitted && v$.client.street.$error" class="invalid-feedback">
                                            <span v-if="v$.client.street.required.$message">
                                                {{ v$.client.street.required.$message }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-4 mb-3">
                                        <label for="city-name-input">City *</label>
                                        <input id="city-name-input" type="text" class="form-control" placeholder="City"
                                            v-model="client.city"
                                            :class="{ 'is-invalid': submitted && v$.client.city.$error, }">
                                        <div v-if="submitted && v$.client.city.$error" class="invalid-feedback">
                                            <span v-if="v$.client.city.required.$message">
                                                {{ v$.client.city.required.$message }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6 mb-3">
                                        <label for="rsp-name-input">Region/State/Province *</label>
                                        <input id="rsp-name-input" type="text" class="form-control"
                                            placeholder="Region/State/Province" v-model="client.state"
                                            :class="{ 'is-invalid': submitted && v$.client.state.$error, }">
                                        <div v-if="submitted && v$.client.state.$error" class="invalid-feedback">
                                            <span v-if="v$.client.state.required.$message">
                                                {{ v$.client.state.required.$message }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6 mb-3">
                                        <label for="pz-name-input">Postal / Zip code *</label>
                                        <input id="pz-name-input" type="text" class="form-control"
                                            placeholder="Postal / Zip code" v-model="client.zipCode"
                                            :class="{ 'is-invalid': submitted && v$.client.zipCode.$error, }">
                                        <!-- <div v-if="submitted && v$.client.zipCode.$error" class="invalid-feedback">
                                            <span v-if="v$.client.zipCode.required.$message">
                                                {{ v$.client.zipCode.required.$message }}
                                            </span>
                                        </div> -->
                                        <div v-for="(client, index) in v$.client.zipCode.$errors" :key="index"
                                            class="invalid-feedback">
                                            <span v-if="client.$message">{{ client.$message }}</span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <label class="form-label">Bio</label>
                                        <textarea type="textarea" v-model="client.bio" placeholder="Bio..."
                                            class="form-control resize-none w-100" rows="6"></textarea>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <div class="">
                                            <label class="form-label">Do Not Submit List </label>
                                            <div class="multipleSelectCstm donot-submit">
                                                <Select2 v-model="client.doNotSubmitList"
                                                    placeholder="Start typing journal name."
                                                    :options="getJournalsName()" :settings="{ multiple: true }" />
                                            </div>
                                            <div class="multipleSelectCstm"
                                                v-if="client.doNotSubmitList.includes('other')">
                                                <vue3-tags-input :tags="tags" add-tag-on-keys="[13]"
                                                    placeholder="Enter Journal Name"
                                                    @on-tags-changed="handleChangeTag" />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-md-6 col-lg-6 mb-3">
                                        <label for="rsp-name-input">Country *</label>
                                        <div class="single-select2-cstm">
                                            <Select2 placeholder="Select Country" :options="countryOption"
                                                v-model="client.country"
                                                :class="{ 'is-invalid': submitted && v$.client.country.$error, }"></Select2>
                                            <div v-if="submitted && v$.client.country.$error" class="invalid-feedback">
                                                <span v-if="v$.client.country.required.$message">
                                                    {{ v$.client.country.required.$message }}
                                                </span>
                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div class="col-md-6 col-lg-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">Phone Number</label>
                                            <input type="text" class="form-control" placeholder="Phone Number"
                                                v-model="client.phone" @input="formatPhoneNumber">
                                        </div>
                                    </div> -->
                                    <div class="col-12 text-end mt-3">
                                        <button type="button" class="btn btn-theme" @click="updateClient">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Change Password" title-item-class="mb-2 customTabLink">
                    <b-card-text>
                        <div class="card overflow-hidden">
                            <div class="card-body">
                                <div class="text-center">
                                    <h1 class="font-size-22 mb-1">Change Password</h1>
                                    <p class="font-size-14">Please enter your new Password</p>
                                </div>
                                <div class="p-2">
                                    <!-- <b-alert v-model="isResetError" class="mb-4" variant="danger" dismissible>{{
                            error
                        }}</b-alert> -->
                                    <b-alert v-model="isResetErrors" class="mb-4" variant="danger" dismissible
                                        v-for="(item, index) in errors" :key="index">{{
                                            item[0]
                                        }}</b-alert>
                                    <!-- <b-alert v-model="isResetSuccess" class="mb-4" variant="success" dismissible>{{
                            success
                        }}</b-alert> -->
                                    <form>
                                        <div class="row">
                                            <div class="mb-3 col-md-6">
                                                <label for="new_password">New Password</label>
                                                <input type="password" v-model="password.new_password"
                                                    name="new_password" class="form-control" id="new_password_id"
                                                    placeholder="Enter New Password"
                                                    :class="{ 'is-invalid': submitted && v2$.password.new_password.$error }" />

                                                <div v-for="(item, index) in v2$.password.new_password.$errors"
                                                    :key="index" class="invalid-feedback">
                                                    <span v-if="item.$message">{{ item.$message }}</span>
                                                </div>

                                            </div>
                                            <div class="mb-3 col-md-6">
                                                <label for="confirm_password">New Confirm Password</label>
                                                <input type="password" v-model="password.confirm_password"
                                                    name="confirm_password" class="form-control"
                                                    id="confirm_password_id" placeholder="Enter Confirm Password"
                                                    :class="{ 'is-invalid': submitted && v2$.password.confirm_password.$error }" />

                                                <div v-for="(item, index) in v2$.password.confirm_password.$errors"
                                                    :key="index" class="invalid-feedback">
                                                    <span v-if="item.$message">{{ item.$message }}</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="mb-3 row mb-0">
                                            <div class="col-12 text-end">
                                                <button @click.prevent="changePassword" class="btn btn-theme w-md"
                                                    type="submit">
                                                    Change Password
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- end card-body -->
                        </div>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </div>
    </layout>
</template>


<script>
import Layout from "../../router/layouts/main";
// import PageHeader from "@/components/page-header";
import Select2 from 'vue3-select2-component';
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import Vue3TagsInput from 'vue3-tags-input';

import {
    required, email,
    // alphaNum,
    helpers,
    minLength
} from "@vuelidate/validators";

/**
 * Tabs & accordions component
 */
export default {
    page: {
        title: "Settings",
    },
    setup() {
        return { v$: useVuelidate(), v2$: useVuelidate() }
    },
    components: { Layout, Select2, Vue3TagsInput },
    data() {
        return {
            title: "Settings",
            url: process.env.VUE_APP_URL,
            submitted: false,
            fetchData: false,
            tags: [],
            journals: [],
            client: {
                firstName: '',
                lastName: '',
                penName: '',
                email: '',
                phone: '',
                doNotSubmitList: [],
                // country: '',
                street: '',
                city: '',
                state: '',
                zipCode: '',
                bio: '',

            },
            userType: null,
            password: {
                new_password: "",
                confirm_password: "",
            },
            errors: {},
            tryingToReset: false,
            isResetError: false,
            isResetErrors: false,
            isResetSuccess: false,
            countryOption: ['Afghanistan', 'Aland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bonaire', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo (Brazzaville)', 'Congo (Kinshasa)', ' Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'uyana', 'Haiti', 'Heard Island and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territories', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Republic of Côte d’Ivoire', 'Republic of Kosovo', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'U.S. Virgin Islands', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican', 'Venezuela', 'Vietnam', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
        };
    },
    validations: {
        client: {
            firstName: {
                required: helpers.withMessage("First Name is required", required),
            },
            lastName: {
                required: helpers.withMessage("Last Name is required", required),
            },
            email: {
                required: helpers.withMessage("Email  is required", required),
                email: helpers.withMessage("Please Enter a valid Email", email),
            },
            country: {
                required: helpers.withMessage("Country  is required", required),
            },
            street: {
                required: helpers.withMessage("Street is required", required),
            },
            city: {
                required: helpers.withMessage("City is required", required),
            },
            state: {
                required: helpers.withMessage("State is required", required),
            },
            zipCode: {
                required: helpers.withMessage("Zip Code is required", required),
                // alphaNum: helpers.withMessage("Zip Code Should Be AlphaNumeric", alphaNum)
            },
        },
        password: {
            new_password: {
                required: helpers.withMessage("New Password is required", required),
                minLength: minLength(8)
            },
            confirm_password: {
                required: helpers.withMessage("Confirm Password is required", required),
                minLength: minLength(8)

            },
        }
    },
    beforeMount() {
        if (!this.fetchData) {
            this.getJournals()
        }
    },
    activated() {
        if (this.fetchData) {
            this.getJournals()
        }
    },
    methods: {
        getJournals() {
            axios.get(this.url + 'api/getJournals').then(res => {
                this.journals = res.data
                this.journals.sort((a, b) => (a.jrnlName > b.jrnlName) ? 1 : -1);
                let journal = { id: 'other', jrnlName: 'Other with fill in option' }
                this.journals[this.journals.length] = journal
                this.getSingleClient()

            })
        },
        getSingleClient() {
            let data = new FormData()
            data.append('id', atob(decodeURIComponent(JSON.parse(localStorage.getItem('authenticatedUserId')))))
            axios.post(this.url + 'api/getSingleClient', data).then(res => {
                this.client = res.data.client
                if ((res.data.client.doNotSubmitList !== '') && (res.data.client.doNotSubmitList !== null)) {
                    let journals = res.data.client.doNotSubmitList
                    this.client.doNotSubmitList = journals.split(',').filter((element) => {
                        return this.journals.map((item) => String(item.id)).includes(element);
                    })
                    this.tags = journals.split(',').filter((element) => {
                        return !this.journals.map((item) => String(item.id)).includes(element);
                    })
                    if (this.tags.length > 0) {
                        this.client.doNotSubmitList[this.client.doNotSubmitList.length] = 'other'
                    }
                    this.tags.sort((a, b) => (a - b) || (a > b ? 1 : -1))

                    // this.tags.sort((a, b) => ( a - b) || (a > b ? 1 : -1));
                }
                else {
                    this.client.doNotSubmitList = []
                    this.tags = []
                }
                this.fetchData = true;
            })
        },
        handleChangeTag(tags) {
            this.tags = tags;
            this.tags.sort((a, b) => (a - b) || (a > b ? 1 : -1));
        },

        getJournalsName() {
            // let journal = this.journals.sort((a, b) => (a.jrnlName > b.jrnlName) ? 1 : -1)
            return this.journals.map(({ id, jrnlName }) => ({
                id: id,
                text: jrnlName
            }));

        },
        formatPhoneNumber() {
            this.client.phone = this.client.phone.replace(/\D/g, "")
            if (this.client.phone.length > 3) {
                this.client.phone = this.client.phone.replace(/(\d{3})(\d{0,3})(\d{0,4})/, "$1-$2-$3");
            } else {
                this.client.phone = this.client.phone.replace(/(\d{0,3})(\d{0,3})/, "$1-$2");
            }
            this.client.phone = this.client.phone.slice(0, 12);
        },
        updateClient() {
            this.submitted = true;
            this.v$.client.$touch();
            if (this.v$.client.$invalid) {
                return;
            } else {
                if (!this.client.doNotSubmitList.some((v) => ["other"].includes(v))) {
                    this.tags = [];
                }
                this.client.doNotSubmitList = this.client.doNotSubmitList.concat(this.tags);
                if (this.client.doNotSubmitList.some((v) => ["other"].includes(v))) {
                    const arrayToRemove = ["other"];
                    for (let i = 0; i < arrayToRemove.length; i++) {
                        let index = this.client.doNotSubmitList.indexOf(
                            arrayToRemove[i]
                        );
                        if (index !== -1) {
                            this.client.doNotSubmitList.splice(index, 1);
                        }
                    }
                }
                axios.post(this.url + 'api/updateClient', this.client).then((res) => {
                    localStorage.setItem('email', JSON.stringify(encodeURIComponent(btoa(res.data.email))));
                    this.$store.state.isAccepted = true
                    this.$store.state.notificationData = 'Profile Updated Successfully'
                    this.$router.push('/dashboard')
                    setTimeout(() => {
                        this.$store.state.isAccepted = false
                        this.$store.state.notificationData = null
                    }, 2500)
                }).catch(error => {
                    this.$store.state.isDeclined = true
                    this.$store.state.notificationData = error.response.data.errors.email[0];
                    setTimeout(() => {
                        this.$store.state.isDeclined = false
                        this.$store.state.notificationData = null
                    }, 2500)
                    console.log(error)
                })
            }

        },
        changePassword() {
            this.submitted = true;
            this.v2$.password.$touch();
            if (this.v2$.password.$invalid) {
                return;
            } else {
                this.isResetErrors = false;
                axios.post(this.url + "api/password/change", {
                    id: atob(decodeURIComponent(JSON.parse(localStorage.getItem('authenticatedUserId')))),
                    new_password: this.password.new_password,
                    confirm_password: this.password.confirm_password
                })
                    .then(() => {
                        this.submitted = false;
                        this.password = {
                            new_password: '',
                            confirm_password: '',
                        }

                        this.$store.state.isAccepted = true
                        this.$store.state.notificationData = 'Password Changed Successfully'
                        setTimeout(() => {
                            this.$store.state.isAccepted = false
                            this.$store.state.notificationData = null
                        }, 2500)
                    }).catch(error => {
                        this.tryingToReset = false;
                        this.isResetSuccess = false;
                        this.isResetError = false;
                        this.errors = error.response.data.errors;
                        this.isResetErrors = true;

                    });
            }
        },
    }
};
</script>
<style lang="css">
.tabs.d-flex {
    --bs-gutter-x: 24px;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(var(--bs-gutter-y)* -1);
    margin-right: calc(var(--bs-gutter-x)* -0.5);
    margin-left: calc(var(--bs-gutter-x)* -0.5);
}
.v3ti .v3ti-tag {
    background: #3aafa9;
}

.select2-container--default .select2-results__option[aria-selected=true] {
    position: relative;
    cursor: no-drop;
    pointer-events: none;
}

.select2-container--default .select2-results__option[aria-selected=true]:after {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    cursor: no-drop;
    pointer-events: none;
}

.multipleSelectCstm .select2-container--default .selection>.select2-selection--multiple {
    min-height: 130px;
    border: 1px solid #ced4da;
    padding: 5px 0;
}

span.select2.select2-container.select2-container--default.select2-container--focus {
    width: 100% !important;
}

span.select2.select2-container.select2-container--default {
    width: 100% !important;
}

.multipleSelectCstm .selection>span.select2-selection.select2-selection--multiple {
    display: flex !important;
    align-items: flex-start !important;
}
</style>